import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Popover,
  Paper,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  IconButton,
  CircularProgress,
  Grid,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
// eslint-disable-next-line no-unused-vars
import { ReportCreate, ReportUpdate, ReportDelete } from '../sections/@dashboard/report';
// api
import API from '../api';

// ----------------------------------------------------------------------

export default function ReportPage() {
  const [open, setOpen] = useState(null);

  const [loading, setLoading] = useState(false);

  const [selectedPerson, setSelectedPerson] = useState({});

  const [people, setPeople] = useState([]);

  const fetchPeople = async () => {
    const response = await API.get('/report');
    const {
      data: { data, success },
    } = response;
    if (success === 1) setPeople(data);
  };

  useEffect(() => {
    try {
      setLoading(true);
      fetchPeople();
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleOpenMenu = (event, data) => {
    setSelectedPerson(data);
    setOpen(event.currentTarget);
  };

  const resetPage = () => {
    setOpen(null);
    setSelectedPerson({});
    fetchPeople();
  };

  return (
    <>
      <Helmet>
        <title> Мэдээлсэн Гэмт хэргүүд </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Мэдээлсэн Гэмт хэргүүд
          </Typography>
          {/* <ReportCreate resetPage={resetPage} /> */}
        </Stack>

        <Scrollbar>
          <Card>
            <Grid container>
              <Grid item xs={6} />
              <Grid item xs={6}>
                {loading && <CircularProgress />}
              </Grid>
            </Grid>
            <TableContainer sx={{ minWidth: 400 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>№</TableCell>
                    <TableCell>Утасны дугаао</TableCell>
                    <TableCell>Нэр</TableCell>
                    <TableCell>Тайлбар</TableCell>
                    <TableCell>Төрөл</TableCell>
                    <TableCell>Огноо</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {people.length > 0 ? (
                    people.map((rowData, index) => {
                      const { r_id, u_phone, u_name, r_desc, r_date, type_name } = rowData;
                      return (
                        <TableRow key={r_id} hover>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap px={2}>
                                {index + 1}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap px={2}>
                                {u_phone}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap>
                                {u_name}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap>
                                {r_desc}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap>
                                {type_name}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="left">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap>
                                {r_date}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="right">
                            <IconButton
                              size="large"
                              color="inherit"
                              onClick={(event) => handleOpenMenu(event, rowData)}
                            >
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Өгөгдөл олдсонгүй
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Scrollbar>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <ReportUpdate selectedPerson={selectedPerson} resetPage={resetPage} />
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <ReportDelete id={selectedPerson.man_id} resetPage={resetPage} />
        </MenuItem>
      </Popover>
    </>
  );
}
